import { splitPrice } from "@utils";
import { Text, View } from "dripsy";
import * as React from "react";

function Price({
  actie,
  actieprijs,
  ppeg,
  isBig = false,
  align = "flex-start",
  zegels,
}: {
  actie: number;
  actieprijs: number;
  ppeg: number;
  isBig?: boolean;
  align?: "flex-start" | "flex-end";
  zegels?: number;
}) {
  const isDiscounted = actie !== 0;
  const discountedPrice = splitPrice(actieprijs);
  const normalPrice = splitPrice(ppeg);
  const bigPrice = isDiscounted ? discountedPrice : normalPrice;

  return (
    <View
      sx={{
        flexDirection: "column",
        alignItems: align,
      }}
    >
      {isDiscounted ? (
        <Text
          sx={{
            fontSize: [13, 14, 15],
            fontWeight: "600",
            color: "$textGrey",
            textDecorationLine: "line-through",
          }}
                 >
          {normalPrice.amount}.{normalPrice.cents}
        </Text>
      ) : null}

      <View sx={{ flexDirection: "row", alignItems: "flex-end" }}>
        {zegels && zegels > 0 ? (
          <Text
            sx={{
              fontSize: [13, 14, 15],
              fontWeight: "600",
              color: "$textGrey",
              marginRight: "$1",
            }}
                     >
            <Text sx={{ fontWeight: "600" }}>
              {zegels}
            </Text>
            <Text sx={{ color: "$textSecondary" }}>
              {" "}
              zegels en
            </Text>
          </Text>
        ) : null}
        <View sx={{ flexDirection: "row" }}>
          <Text sx={{ fontSize: isBig ? [20, 22, 26] : [16, 18, 20], fontWeight: "700" }}>
            {bigPrice.amount + "."}
          </Text>
          <Text
                       sx={{
              fontSize: isBig ? [13, 14, 15] : [12, 13, 14],
              marginTop: [1, 2],
              marginLeft: -2,
              fontWeight: "600",
            }}
          >
            {bigPrice.cents}
          </Text>
        </View>
      </View>
    </View>
  );
}

export default Price;
